// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".GenePage-module__geneEnsemblInfo__3uKU8{font-size:0.8rem}.GenePage-module__geneEnsemblInfo__3uKU8,.GenePage-module__lowKeyLinkout__1du-t{color:gray}.GenePage-module__sameLineSpans__3YcD-{display:flex;flex-wrap:wrap}.GenePage-module__sameLineSpans__3YcD->span{margin:0 0.3rem}.GenePage-module__sameLineSpans__3YcD->span:first-child{margin-left:0}.GenePage-module__sameLineSpans__3YcD->span:last-child{margin-left:0}.RRT__panel.GenePage-module__panel__3cyq_{border-width:1px 0 0;padding-left:0;padding-right:0}.GenePage-module__infoTileContainer__2lgbm{display:flex;gap:0.5rem;flex-wrap:wrap}.GenePage-module__evenInfoTile__1RLKF{flex:1 1 calc(50% - 0.25rem)}.GenePage-module__autoInfoTile__36snS{flex:1 1 auto}.GenePage-module__infoTile__3mIZ_{flex-grow:1}\n", ""]);
// Exports
exports.locals = {
	"geneEnsemblInfo": "GenePage-module__geneEnsemblInfo__3uKU8",
	"lowKeyLinkout": "GenePage-module__lowKeyLinkout__1du-t",
	"sameLineSpans": "GenePage-module__sameLineSpans__3YcD-",
	"panel": "GenePage-module__panel__3cyq_",
	"infoTileContainer": "GenePage-module__infoTileContainer__2lgbm",
	"evenInfoTile": "GenePage-module__evenInfoTile__1RLKF",
	"autoInfoTile": "GenePage-module__autoInfoTile__36snS",
	"infoTile": "GenePage-module__infoTile__3mIZ_"
};
module.exports = exports;
